import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MeetingNoticeForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gpName: '',
    meetingType: '',
    meetingLocation: '',
    meetingDate: '',
    meetingDay: '',
    noticeDate: '',
    meetingPeriod: 'सकाळी',
    meetingTime: '',
    selectedSubjects: '',
    allSubjects: [
      'मराठी भाषेला अभिजात भाषेचा दर्जा मिळाल्याबद्दल केंद्र शासनाचे अभिनंदन करणेबाबत.',
      'मागील सभेचे इतिवृत्त वाचून कायम करणे.',
      'ग्रामपंचायत स्वनिधी अंदाजपत्रक मंजूर करणे.',
      '१५ व्या वित्त आयोग कृती आराखडा मंजूर करणे.'
    ]
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              visibility: hidden;
              background: white !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 10mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 min-w-[1000px] flex justify-between items-center gap-2">
          <h2 className="text-[#b71c1c] text-left shrink text-[14px] sm:text-[17px] font-bold flex items-center  gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> सभा नोटीस
          </h2>
          <button onClick={() => navigate(-1)} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
              मागे जा
            </button>
        </div>

        <div className="p-6 min-w-[1000px]">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-6">
            
            {/* Row 1 */}
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ग्रामपंचायतीचे नाव</label>
              <select name="gpName" value={formData.gpName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">ग्रामपंचायत निवडा</option>
                <option value="धामणी">धामणी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचा प्रकार निवडा</label>
              <select name="meetingType" value={formData.meetingType} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेचा प्रकार निवडा</option>
                <option value="मासिक सभा">मासिक सभा</option>
                <option value="विशेष सभा">विशेष सभा</option>
                <option value="ग्रामसभा">ग्रामसभा</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचे ठिकाण</label>
              <select name="meetingLocation" value={formData.meetingLocation} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेचे ठिकाण</option>
                <option value="ग्रामपंचायत कार्यालय">ग्रामपंचायत कार्यालय</option>
                <option value="समाज मंदिर">समाज मंदिर</option>
              </select>
            </div>

            {/* Row 2 */}
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचा दिनांक</label>
              <input type="date" name="meetingDate" value={formData.meetingDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचा वार</label>
              <select name="meetingDay" value={formData.meetingDay} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेचा वार निवडा</option>
                <option value="सोमवार">सोमवार</option>
                <option value="मंगळवार">मंगळवार</option>
                <option value="बुधवार">बुधवार</option>
                <option value="गुरुवार">गुरुवार</option>
                <option value="शुक्रवार">शुक्रवार</option>
                <option value="शनिवार">शनिवार</option>
                <option value="रविवार">रविवार</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">नोटीसचा दिनांक</label>
              <input type="date" name="noticeDate" value={formData.noticeDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            {/* Row 3 */}
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचा काळ</label>
              <select name="meetingPeriod" value={formData.meetingPeriod} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="सकाळी">सकाळी</option>
                <option value="दुपारी">दुपारी</option>
                <option value="संध्याकाळी">संध्याकाळी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेची वेळ</label>
              <select name="meetingTime" value={formData.meetingTime} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">सभेची वेळ निवडा</option>
                <option value="10:00 AM">10:00 AM</option>
                <option value="11:00 AM">11:00 AM</option>
                <option value="12:00 PM">12:00 PM</option>
                <option value="01:00 PM">01:00 PM</option>
                <option value="02:00 PM">02:00 PM</option>
              </select>
            </div>
            <div></div>

            {/* Subject Selection Row */}
            <div className="md:col-span-1 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">सभेचे विषय निवडा</label>
              <select 
                multiple 
                className="border border-[#ccc] rounded-sm px-2 py-1 text-sm bg-white outline-none focus:border-blue-400 h-40"
                onChange={(e) => {
                  const values = Array.from(e.target.selectedOptions, option => option.value);
                  setFormData(prev => ({ ...prev, selectedSubjects: values.join('\n') }));
                }}
              >
                {formData.allSubjects.map((sub, i) => <option key={i} value={sub}>{sub}</option>)}
              </select>
              <p className="text-[10px] text-gray-500 mt-1 italic">एकापेक्षा अधिक विषय निवडण्यासाठी कृपया Ctrl बटनाचा वापर करा.</p>
            </div>

            <div className="md:col-span-2 flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">निवडलेले विषय:</label>
              <textarea 
                readOnly
                value={formData.selectedSubjects}
                className="border border-[#ccc] rounded-sm px-3 py-2 text-sm outline-none bg-gray-50 h-40 resize-none"
              ></textarea>
            </div>

          </div>

          <div className="mt-10 flex gap-4 justify-center">
            <button onClick={handlePrint} className="bg-[#00a65a] text-white px-20 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button className="bg-[#f39c12] text-white px-10 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Generate Document</button>
          </div>

          <div className="mt-8 border border-gray-300 rounded-sm min-h-[400px] bg-white"></div>

          <div className="mt-4">
            <button className="bg-[#f4f4f4] border border-[#ddd] text-[#444] px-5 py-1.5 rounded-sm text-xs flex items-center gap-2 hover:bg-[#e8e8e8]">
              <span>🖨️</span> Print
            </button>
          </div>
        </div>
      </div>

      {/* Printable Notice Area */}
      <div id="printable-area" className="hidden print:block font-serif text-black bg-white">
        <div className="text-center mb-10">
          <h1 className="text-[22px] font-bold">ग्रामपंचायत कार्यालय: {formData.gpName}</h1>
          <p className="text-[16px] font-bold mt-1">सभेची नोटीस</p>
        </div>

        <div className="flex justify-between mb-8">
          <div>जा.क्र./ग्रा.पं./नोटीस/२०२५-२६/</div>
          <div>दिनांक: {formData.noticeDate}</div>
        </div>

        <p className="text-[16px] leading-relaxed mb-6 text-justify">
          ग्रामपंचायत {formData.gpName} मधील सर्व सदस्य/ग्रामस्थांना कळविण्यात येते की, ग्रामपंचायतीची **{formData.meetingType}** दिनांक **{formData.meetingDate}** ({formData.meetingDay}) रोजी **{formData.meetingPeriod} {formData.meetingTime}** वाजता **{formData.meetingLocation}** येथे आयोजित करण्यात आली आहे.
        </p>

        <p className="text-[16px] mb-4">सभेचे विषय खालीलप्रमाणे आहेत:</p>

        <div className="pl-8 mb-10">
          {formData.selectedSubjects.split('\n').map((sub, i) => (
            <p key={i} className="mb-2">{i + 1}) {sub}</p>
          ))}
        </div>

        <p className="text-[16px] mb-16 text-justify">
          तरी सदर सभेस सर्वांनी वेळेवर उपस्थित राहावे ही विनंती.
        </p>

        <div className="flex justify-between items-end mt-20 pr-10 pl-10 font-bold">
          <div className="text-center">
            <p>ग्रामसेवक /ग्रामविकास अधिकारी</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
          <div className="text-center">
            <p>सरपंच</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingNoticeForm;
